// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tSU8","importantInfo":"styles_importantInfo__13phH"};